import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  ConfigureStore: {
    description: 'orderAlerts.configureStore',
    defaultMessage: 'Unconfigured Store',
    id: 'kOIsDW',
  },
  ShipTogether: {
    description: 'orderAlerts.mergeOrders',
    defaultMessage: 'Combine Orders',
    id: 'fuBVGV',
  },
  NewProducts: {
    description: 'orderAlerts.newProducts',
    defaultMessage: 'Unconfigured Products',
    id: 'XELl/y',
  },
  AutomationRuleAction: {
    description: 'orderAlerts.customRuleAction',
    defaultMessage: 'Custom Alert',
    id: 'x3R12o',
  },
  AutoShipFBAError: {
    description: 'orderAlerts.autoShipFBAError',
    defaultMessage: 'Auto-Fulfill Warning',
    id: '7ElPdA',
  },
  ReturnsImport: {
    description: 'orderAlerts.returnsImport',
    defaultMessage: 'Return Import',
    id: 'ia+7Ya',
  },
  OrderRejected: {
    description: 'orderAlerts.orderRejected',
    defaultMessage: 'Order Import',
    id: 'iuuKqf',
  },
  MergeCustomer: {
    description: 'orderAlerts.mergeCustomer',
    defaultMessage: 'Combine Customers',
    id: 'OJrXaa',
  },
  InventoryThresholdWarning: {
    description: 'orderAlerts.inventoryThresholdWarning',
    defaultMessage: 'Inventory Threshold Warning',
    id: 'xBLhIt',
  },
  LocalDeliveryException: {
    description: 'orderAlerts.localDeliveryException',
    defaultMessage: 'Local Delivery Exception',
    id: 'Fpb3Hc',
  },
  Undetermined: {
    description: 'orderAlerts.undetermined',
    defaultMessage: 'Unknown Alert Type',
    id: 'HZ5Us4',
  },
  OrdersDeallocated: {
    description: 'alert type row header for information on orders that were deallocated as a consequence to deallocating a product',
    defaultMessage: 'Orders Deallocated',
    id: 'BNH4Lm',
  },
  RejectedFulfillment: {
    description: 'alert type row header for information on fulfillments that were rejected by a fulfillment provider',
    defaultMessage: 'Rejected Fulfillment',
    id: 'OnT2Dg',
  },
});
